export default function SyncPanel({
  syncedFromEconomics,
  syncedActuals,
  syncMessage,
  onPull,
  onPush,
  onDismissMessage,
  pushDisabled = false,
}) {
  return (
    <section className="chart-card economics-panel">
      <h2>Economics sync</h2>
      <p className="chart-hint">
        Pull plan prices, weighted ARPU, and split Plaid/Stripe COGS from the Economics module.
        Push forecast P50 logos back to Economics <code>startPaying</code>.
      </p>

      <div className="economics-preset-row">
        <button type="button" className="primary-button" onClick={onPull}>
          Pull prices &amp; COGS from Economics
        </button>
        <button
          type="button"
          className="secondary-button"
          onClick={onPush}
          disabled={pushDisabled}
        >
          Send Forecast P50 logos → Economics startPaying
        </button>
      </div>
      {pushDisabled ? (
        <p className="chart-hint">Waiting for Monte Carlo P50</p>
      ) : null}

      {syncMessage && (
        <p className="module-status economics-callout" role="status">
          {syncMessage}
          <button
            type="button"
            className="secondary-button forecast-dismiss-btn"
            onClick={onDismissMessage}
          >
            Dismiss
          </button>
        </p>
      )}

      {syncedFromEconomics && (
        <div className="forecast-sync-meta">
          <h3 className="economics-subheading">Last Economics sync</h3>
          <ul className="economics-roadmap-list">
            <li>At: {new Date(syncedFromEconomics.at).toLocaleString()}</li>
            <li>ARPU: ${syncedFromEconomics.arpu}</li>
            <li>
              Plaid / linked logo: ${syncedFromEconomics.plaidCogs ?? '—'} · Stripe / paid logo: $
              {syncedFromEconomics.stripeCogs ?? '—'}
            </li>
            <li>Start paying: {syncedFromEconomics.startPaying}</li>
          </ul>
        </div>
      )}

      {syncedActuals?.mrrSeries?.length > 0 && (
        <div className="forecast-sync-meta">
          <h3 className="economics-subheading">Synced actuals (Stripe)</h3>
          <ul className="economics-roadmap-list">
            <li>
              As of:{' '}
              {syncedActuals.asOf
                ? new Date(syncedActuals.asOf).toLocaleString()
                : '—'}
            </li>
            <li>Trailing MRR points: {syncedActuals.mrrSeries.length}</li>
            {syncedActuals.logosSeries?.length ? (
              <li>Trailing logo points: {syncedActuals.logosSeries.length}</li>
            ) : null}
          </ul>
        </div>
      )}

      <p className="economics-muted">
        Economics data is read from the current Economics v4 scenario (falls back through v3, v2, and v1). Forecast working copy is v7.
        Push only updates <code>growth.startPaying</code> — other Economics fields are untouched.
      </p>
    </section>
  );
}
